import { getEntries } from '@deltasierra/utilities-object';

export type URLParams = Record<string, any>

export class URLParamsBuilder {
    public params: URLParams = {};

    public add(key: string, value: any): this {
        this.params[key] = value;
        return this;
    }

    public build(): string {
        return getEntries(this.params)
            .map(([key, value]) => `${key}=${value}`)
            .join('&');
    }
}

export class URLBuilder extends URLParamsBuilder {
    public constructor(private baseUrl: string) {
        super();
    }

    public build(): string {
        const url = this.baseUrl;

        // If we already have a '?' in the URL append the '&' otherwise the '?'
        const separator = url.includes('?') ? '&' : '?';

        const builtParams = super.build();
        return builtParams ? `${url}${separator}${builtParams}` : url;
    }
}
